import { mapSagasFromConfigurations } from '../../helpers/sagas';
import { configurations } from './configurations';

function* cpdPointSagas() {
  yield mapSagasFromConfigurations('cpdPoints')(configurations)
}

export default cpdPointSagas;


// WEBPACK FOOTER //
// ./src/state/modules/cpd-points/sagas.js